export default "__VITE_ASSET__BEhzxl5b__"